export default function NotFound() {
	return <>404</>;
}
